import { render, staticRenderFns } from "./AvoidedCostsNature.vue?vue&type=template&id=360e3865&scoped=true"
import script from "./AvoidedCostsNature.vue?vue&type=script&lang=js"
export * from "./AvoidedCostsNature.vue?vue&type=script&lang=js"
import style0 from "./AvoidedCostsNature.vue?vue&type=style&index=0&id=360e3865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e3865",
  null
  
)

export default component.exports